import { render } from "./WhatsAppModalSidebarLeftCountryFlagAvatar.vue?vue&type=template&id=4d7d8022"
import script from "./WhatsAppModalSidebarLeftCountryFlagAvatar.vue?vue&type=script&lang=js"
export * from "./WhatsAppModalSidebarLeftCountryFlagAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__